import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router";

import { getSupabase } from "../lib/supabase";

export function AuthCallbackRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const code = params.get("code");
  // Supabase consumes the OAuth code exactly once; React 18 StrictMode
  // double-invokes effects in dev, so guard against the second call failing
  // with "invalid grant" and bouncing the user to /auth/login.
  const consumed = useRef(false);

  useEffect(() => {
    if (!code || consumed.current) return;
    consumed.current = true;
    getSupabase()
      .auth.exchangeCodeForSession(code)
      .then(({ error }) => {
        if (error) throw error;
        navigate("/", { replace: true });
      })
      .catch((err) => {
        console.error("[auth.callback] PKCE exchange failed", err);
        const reason = err instanceof Error ? err.message : "unknown";
        navigate(`/auth/login?error=${encodeURIComponent(reason)}`, { replace: true });
      });
  }, [navigate, code]);

  return (
    <div className="mx-auto max-w-md px-4 py-12 text-center text-fg-mute">
      <h1 className="text-xl font-medium">{t("auth.loading_title")}</h1>
    </div>
  );
}
